import React, { createContext, ReactElement, ReactNode } from "react"
import AuthStore from "./AuthStore"
import RegistrationStore from "./RegistrationStore"
import rootStore, { RootStore } from "./RootStore"
import StripeStore from "./StripeStore"
import AdditionalTestingStore from "./AdditionalTestingStore"

export const StoreContext = createContext<RootStore>(rootStore)

interface StoreProviderProps {
  children: ReactNode
}

export function StoreProvider({ children }: StoreProviderProps): ReactElement  {
  return <StoreContext.Provider value={rootStore}>{children}</StoreContext.Provider>
}

export function useAuthStore(): AuthStore {
  return React.useContext(StoreContext).authStore
}

export function useStripeStore(): StripeStore {
  return React.useContext(StoreContext).stripeStore
}

export function useRegistrationStore(): RegistrationStore {
  return React.useContext(StoreContext).registrationStore
}

export function useAdditionalTestingStore(): AdditionalTestingStore {
  return React.useContext(StoreContext).additionalTestingStore
}
